import { render } from "./recoverPasswordComponent.vue?vue&type=template&id=5e098eb4"
import script from "./recoverPasswordComponent.vue?vue&type=script&lang=js"
export * from "./recoverPasswordComponent.vue?vue&type=script&lang=js"

import "./recoverPasswordComponent.vue?vue&type=style&index=0&id=5e098eb4&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__